import React from 'react';
import { Form, Col} from 'react-bootstrap';
import ApplicationHelpers from '../../ApplicationHelpers';

/*
    props
    form
    type client/spouse
*/
export default class Age extends React.Component {
    render(){
        let birthdate = '';
         let form = this.props.form;
         if(this.props.type === 'client'){
             birthdate = form.client.birthdate;
         }
         else if(this.props.type === 'spouse'){
            birthdate = form.client.spouse.birthdate;
         }
         let ages = ApplicationHelpers.ageAt(new Date(birthdate),new Date(),true);
        return(
            // <Badge variant="secondary">{`Age ${ages} years`}</Badge>
            <Form.Group as={Col} md="4" controlId="validationFormikCurrentAge">
                        <Form.Label>Current Age</Form.Label>
                        <Form.Control
                                type="number"
                                onChange={e=>console.log(e)}
                                value={ages}
                                disabled={true}
                        />
                    </Form.Group>
        );
    }
}